function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: none;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100px; // 120px에서 100px로 추가 감소\n  background-color: ",
        "; // Use theme.paper instead of theme.grey[...]\n  overflow: hidden;\n  cursor: ",
        ";\n\n  @media (min-width: ",
        ") {\n    height: 110px; // 140px에서 110px로 추가 감소\n  }\n  @media (min-width: ",
        ") {\n    height: 130px; // 170px에서 130px로 추가 감소\n  }\n  \n  /* 화면 높이에 따른 반응형 추가 */\n  @media (max-height: 700px) {\n    height: 80px;\n  }\n  @media (max-height: 600px) {\n    height: 60px;\n  }\n\n  &:hover .cover-overlay {\n    opacity: ",
        ";\n    pointer-events: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover; // 이미지가 비율 유지하며 꽉 차도록\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n  color: white;\n  font-weight: 600;\n  pointer-events: none; // 기본적으로 클릭 방지\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 0;\n  left: ",
        ";\n  transform: translateY(50%); // Overlap effect for larger screens\n  border: 4px solid ",
        ";\n  border-radius: 50%;\n  background-color: ",
        ";\n  overflow: hidden;\n  cursor: ",
        ";\n  width: 128px; // Default size (lg/xl avatar?)\n  height: 128px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1; // Ensure profile image is above cover\n  \n  /* Playwright 호환성: hover 없이도 클릭 시각 피드백 */\n  ",
        "\n\n  @media (max-width: ",
        ") {\n    position: relative;\n    width: 96px;\n    height: 96px;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: auto;\n    margin-top: -48px;\n    border-width: 3px;\n  }\n  \n  /* 화면 높이에 따른 반응형 추가 */\n  @media (max-height: 700px) {\n    width: 96px;\n    height: 96px;\n    border-width: 3px;\n  }\n  @media (max-height: 600px) {\n    width: 80px;\n    height: 80px;\n    border-width: 2px;\n  }\n\n  &:hover .profile-overlay {\n    opacity: ",
        ";\n    pointer-events: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  border-radius: 50%; // 프로필 오버레이는 둥글게\n  font-size: 12px;\n  cursor: pointer; // 클릭 가능 표시\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useRef, useState, useMemo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { ImageDisplay, Avatar } from '@edusense/shared-ui-kit';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Camera } from 'lucide-react';
import { PROFILE_EDIT_TEST_IDS } from '@edusense/shared-constants';
// 기본 커버 이미지 URL (미니멀 그라디언트)
var DEFAULT_COVER_IMAGE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjQwMCIgdmlld0JveD0iMCAwIDEyMDAgNDAwIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNlMmU4ZjAiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNjYmQ1ZTEiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBmaWxsPSJ1cmwoI2EpIiBkPSJNMCAwaDEyMDB2NDAwSDB6Ii8+PC9zdmc+';
// --- Styled Components ---
var BannerContainer = styled.div(_templateObject());
var HiddenInput = styled.input(_templateObject1());
var CoverImageWrapper = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.paper;
}, function(param) {
    var isEditable = param.isEditable;
    return isEditable ? 'pointer' : 'default';
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.md;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.lg;
}, function(param) {
    var isEditable = param.isEditable;
    return isEditable ? 1 : 0;
}, function(param) {
    var isEditable = param.isEditable;
    return isEditable ? 'auto' : 'none';
});
var StyledImageDisplay = styled(ImageDisplay)(_templateObject3());
var OverlayBase = styled.div(_templateObject4());
var CoverOverlay = styled(OverlayBase)(_templateObject5());
var ProfileImageContainer = styled.div(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing.md;
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var isEditable = param.isEditable;
    return isEditable ? 'pointer' : 'default';
}, function(param) {
    var isEditable = param.isEditable;
    return isEditable && "\n    &:active {\n      transform: translateY(50%) scale(0.98);\n      transition: transform 0.1s ease;\n    }\n  ";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.sm;
}, function(param) {
    var isEditable = param.isEditable;
    return isEditable ? 1 : 0;
}, function(param) {
    var isEditable = param.isEditable;
    return isEditable ? 'auto' : 'none';
});
// 커스텀 Avatar 사용 (shared-ui-kit)
var CustomProfileAvatar = function(param) {
    var username = param.username, name = param.name, profileImage = param.profileImage;
    return /*#__PURE__*/ React.createElement(Avatar, {
        username: username,
        name: name || '',
        profileImage: profileImage !== null && profileImage !== void 0 ? profileImage : undefined,
        size: 128,
        border: "none"
    });
};
var ProfileOverlay = styled(OverlayBase)(_templateObject7());
// --- Component Implementation ---
var ProfileBanner = function(param) {
    var username = param.username, name = param.name, profileImage = param.profileImage, coverImage = param.coverImage, _param_isEditable = param.isEditable, isEditable = _param_isEditable === void 0 ? false : _param_isEditable, onProfileImageClick = param.onProfileImageClick, onCoverImageClick = param.onCoverImageClick;
    var theme = useTheme();
    var profileInputRef = useRef(null);
    var coverInputRef = useRef(null);
    var _useState = _sliced_to_array(useState(null), 2), profilePreviewUrl = _useState[0], setProfilePreviewUrl = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), coverPreviewUrl = _useState1[0], setCoverPreviewUrl = _useState1[1];
    // Playwright 호환성: input files 변화 감지
    React.useEffect(function() {
        if (!profileInputRef.current) return;
        var inputElement = profileInputRef.current;
        // MutationObserver로 files 속성 변화 감지
        var observer = new MutationObserver(function() {
            if (inputElement.files && inputElement.files.length > 0) {
                console.log('🟡 [ProfileBanner] MutationObserver: 파일 변화 감지됨!');
                console.log('🟡 [ProfileBanner] 파일 개수:', inputElement.files.length);
                // 수동으로 change 이벤트 트리거
                triggerFileChangeEvent(inputElement);
            }
        });
        // 속성 변화 관찰 시작
        observer.observe(inputElement, {
            attributes: true,
            attributeFilter: [
                'value'
            ],
            childList: false,
            subtree: false
        });
        // 주기적 polling으로 files 변화 체크 (fallback)
        var pollInterval = setInterval(function() {
            if (inputElement.files && inputElement.files.length > 0) {
                console.log('🟡 [ProfileBanner] Polling: 파일 변화 감지됨!');
                triggerFileChangeEvent(inputElement);
                clearInterval(pollInterval);
            }
        }, 500);
        return function() {
            observer.disconnect();
            clearInterval(pollInterval);
        };
    }, []);
    // 프로필 이미지 클릭 핸들러
    var handleProfileImageClick = function() {
        if (isEditable && profileInputRef.current) {
            profileInputRef.current.click();
        }
    };
    // 커버 이미지 클릭 핸들러
    var handleCoverImageClick = function() {
        if (isEditable && coverInputRef.current) {
            coverInputRef.current.click();
        }
    };
    // 프로필 이미지 변경 핸들러 (Playwright 호환성 개선)
    var handleProfileImageChange = function(e) {
        var _e_target_files;
        console.log('🔴 [ProfileBanner] handleProfileImageChange 호출됨!');
        console.log('🔴 [ProfileBanner] e.target.files:', e.target.files);
        console.log('🔴 [ProfileBanner] e.isTrusted:', e.isTrusted);
        console.log('🔴 [ProfileBanner] e.type:', e.type);
        var file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file) {
            console.log('🔴 [ProfileBanner] 프로필 이미지 파일 선택됨:', file.name, file.size);
            // 파일 미리보기 생성
            var reader = new FileReader();
            reader.onload = function(event) {
                var _event_target;
                var result = (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.result;
                console.log('[ProfileBanner] 프로필 이미지 미리보기 생성됨:', result.substring(0, 30) + '...');
                setProfilePreviewUrl(result);
            };
            reader.readAsDataURL(file);
            // 부모 컴포넌트에 파일 전달
            if (onProfileImageClick) {
                onProfileImageClick(file);
            }
            // 입력 필드 초기화하여 같은 파일 다시 선택 가능하게 함
            e.target.value = '';
        }
    };
    // Playwright 호환성을 위한 수동 이벤트 트리거 함수
    var triggerFileChangeEvent = function(inputElement) {
        console.log('🟡 [ProfileBanner] 수동 change 이벤트 트리거링...');
        // 다양한 이벤트 타입으로 시도
        var events = [
            'change',
            'input'
        ];
        events.forEach(function(eventType) {
            var event = new Event(eventType, {
                bubbles: true,
                cancelable: true
            });
            Object.defineProperty(event, 'target', {
                value: inputElement,
                enumerable: true
            });
            Object.defineProperty(event, 'currentTarget', {
                value: inputElement,
                enumerable: true
            });
            console.log("\uD83D\uDFE1 [ProfileBanner] ".concat(eventType, " 이벤트 디스패치 중..."));
            inputElement.dispatchEvent(event);
        });
    };
    // 커버 이미지 변경 핸들러
    var handleCoverImageChange = function(e) {
        var _e_target_files;
        var file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file) {
            console.log('[ProfileBanner] 커버 이미지 파일 선택됨:', file.name, file.size);
            // 파일 미리보기 생성
            var reader = new FileReader();
            reader.onload = function(event) {
                var _event_target;
                var result = (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.result;
                console.log('[ProfileBanner] 커버 이미지 미리보기 생성됨:', result.substring(0, 30) + '...');
                setCoverPreviewUrl(result);
            };
            reader.readAsDataURL(file);
            // 부모 컴포넌트에 파일 전달
            if (onCoverImageClick) {
                onCoverImageClick(file);
            }
            // 입력 필드 초기화하여 같은 파일 다시 선택 가능하게 함
            e.target.value = '';
        }
    };
    // 커버 이미지 오류 처리 핸들러
    var handleCoverImageError = function() {
        console.log('[ProfileBanner] 커버 이미지 로드 실패');
    };
    // 실제 표시될 이미지 URL
    var displayProfileImage = profilePreviewUrl || profileImage;
    var displayCoverImage = coverPreviewUrl || coverImage;
    // 로그 제거: 운영에서 불필요한 디버그 출력 방지
    // 이미지 안정적인 키 생성
    var coverImageKey = useMemo(function() {
        var sourceId = displayCoverImage || 'default';
        // URL에서 고유 식별자 생성 (파일명 또는 해시 부분)
        var uniquePart = '';
        if (typeof sourceId === 'string') {
            var parts = sourceId.split('/');
            uniquePart = parts[parts.length - 1] || sourceId.substring(0, 10);
        }
        return "cover-".concat(uniquePart.replace(/[^a-zA-Z0-9]/g, ''), "-").concat(username);
    }, [
        displayCoverImage,
        username
    ]);
    return /*#__PURE__*/ React.createElement(BannerContainer, null, /*#__PURE__*/ React.createElement(HiddenInput, {
        type: "file",
        ref: coverInputRef,
        accept: "image/*",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_COVER_INPUT,
        onChange: handleCoverImageChange
    }), /*#__PURE__*/ React.createElement(HiddenInput, {
        type: "file",
        ref: profileInputRef,
        accept: "image/*",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_AVATAR_INPUT,
        onChange: handleProfileImageChange
    }), /*#__PURE__*/ React.createElement(CoverImageWrapper, {
        isEditable: isEditable,
        onClick: isEditable ? handleCoverImageClick : undefined,
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_COVER_TRIGGER
    }, /*#__PURE__*/ React.createElement(StyledImageDisplay, {
        key: coverImageKey,
        src: displayCoverImage || '',
        fallbackSrc: DEFAULT_COVER_IMAGE,
        alt: "커버 이미지",
        onError: handleCoverImageError,
        showErrorUI: false
    }), isEditable && /*#__PURE__*/ React.createElement(CoverOverlay, {
        className: "cover-overlay"
    }, /*#__PURE__*/ React.createElement(Camera, {
        size: 24,
        style: {
            marginRight: theme.spacing.xs
        }
    }), /*#__PURE__*/ React.createElement("span", null, "커버 변경"))), /*#__PURE__*/ React.createElement(ProfileImageContainer, {
        isEditable: isEditable,
        onClick: isEditable ? handleProfileImageClick : undefined,
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_AVATAR_TRIGGER
    }, /*#__PURE__*/ React.createElement(CustomProfileAvatar, {
        username: username,
        name: name,
        profileImage: displayProfileImage !== null && displayProfileImage !== void 0 ? displayProfileImage : null
    }), isEditable && /*#__PURE__*/ React.createElement(ProfileOverlay, {
        className: "profile-overlay"
    }, /*#__PURE__*/ React.createElement(Camera, {
        size: 16,
        style: {
            marginRight: theme.spacing.xs
        }
    }), /*#__PURE__*/ React.createElement("span", null, "변경"))));
};
export default ProfileBanner;
